import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ children, to, onClick, className = "", type = "button" }) => {
    if (to) {
        return (
            <Link
                className={`rounded-pill btn solid_btn ${className}`}
                to={to}
                onClick={onClick}
            >
                {children || "Contact Us"} <i className="fas fa-chevron-right"></i>
            </Link>
        );
    }

    return (
        <button
            type={type}
            className={`rounded-pill btn solid_btn ${className}`}
            onClick={onClick}
        >
            {children || "Contact Us"} <i className="fas fa-chevron-right"></i>
        </button>
    );
};

export default Button;
